( ( $ ) => {

	const pattern_13_position = $( '.pattern--type-13' ).position();

	const phr_news_tab_sticky = ( ev ) => {

		if ( 
			'/press-releases/' != window.location.pathname && 
			'/news/' != window.location.pathname
		)
		{
			return;
		}

		if ( $( '.pattern--type-13' ).length > 0 )
		{
			var content_total_distance	= 0;

			if ( $( '.header-components' ).length > 0 )
			{
				content_total_distance += $( '.header-components' ).outerHeight();
			}

			if ( $( '.site-wide-notification' ).length > 0 )
			{
				content_total_distance += $( '.site-wide-notification' ).outerHeight();
			}

			if ( $( '#wpadminbar' ).length > 0 ) // molesta cuando no hay wpadminbar igual nomas
			{
				content_total_distance += $( '#wpadminbar' ).outerHeight();
			}

			if ( $( '#wp-admin-bar-wp-logo' ).is( ':hidden' ) )
			{
				content_total_distance -= $( '#wpadminbar' ).outerHeight();
			}

			const initial_breakpoint = parseInt( pattern_13_position.top );
			const scroll_breakpoint = $( document ).scrollTop() + content_total_distance;

			if ( scroll_breakpoint >= initial_breakpoint )
			{
				$( '.pattern--type-13' )
					.addClass( 'fixed-top' )
					.prop( 'style', 'margin-top: ' + content_total_distance + 'px;' )
					.next()
					.prop( 'style', 'margin-top: ' + $( '.pattern--type-13' ).outerHeight() + 'px;' );
			}
			else
			{
				$( '.pattern--type-13' )
					.prop( 'style', false )
					.removeClass( 'fixed-top' )
					.next()
					.prop( 'style', false );
			}

			// console.log( scroll_breakpoint, initial_breakpoint );
		}
	}

	phr_news_tab_sticky();
	$( window ).on( 'scroll', phr_news_tab_sticky );
	$( window ).on( 'resize', phr_news_tab_sticky );

} )( jQuery );